import { getFeedsComments } from '@op/services';
import { AnalysisMetricList } from '../constants/SocialMediaColumns';
import { DownloadConfigInfoType } from '../types';
import {
  getAllLogValue,
  getLogValue,
} from '@op/pages/feeds/hooks/useFeedsRequest';
import { uniqueArray } from '@op/utils';

function mergeKeywordList(filter: {
  keyword: string[];
  keywords_list: string[][];
}) {
  const { keyword = [], keywords_list = [] } = filter;
  const keywordList = [...keyword, ...keywords_list].flat(Infinity);
  return keywordList as string[];
}

export const SocialMediaDownload: DownloadConfigInfoType = {
  type: 'page',
  customizeDownloadFunc: async ({ filter, auxiliaryParams }) => {
    const { hideSentimentRating } = auxiliaryParams;
    const data = await getFeedsComments(filter);
    const { list = [], total } = data;
    const sentimentMap = await getAllLogValue(
      list,
      {},
      { value_type: ['sentiment', 'topic', 'valid'] },
    );

    const dataList = list.map(
      (item: {
        content: string;
        content_to_en: string;
        content_to_zh: string;
        sentiment_rating: any;
        topic: string;
        isvalid: string;
      }) => {
        const [newSentiment, newTopic, newValid] = [
          'latest_sentiment',
          'latest_topic',
          'latest_valid',
        ].map(key => getLogValue(sentimentMap, item, key as any));

        const sentimentDefaultValue = hideSentimentRating
          ? null
          : item.sentiment_rating;

        const keywordIncluded = mergeKeywordList(filter)
          .map((keyword: string) => {
            const text = keyword?.toLocaleLowerCase();
            const content = item.content?.toLocaleLowerCase();
            const contentToZh = item.content_to_zh?.toLocaleLowerCase();
            const contentToEn = item.content_to_en?.toLocaleLowerCase();
            const flag =
              content.includes(text) ||
              contentToZh.includes(text) ||
              contentToEn.includes(text);
            if (flag) {
              return keyword;
            }
            return null;
          })
          .filter(Boolean);

        const realList = uniqueArray(keywordIncluded || []);

        return {
          ...item,
          sentiment_rating: newSentiment || sentimentDefaultValue,
          isvalid: newValid || item.isvalid,
          topic: newTopic || item.topic,
          keyword_included: realList.join(',')
        };
      },
    ); 
    return {
      list: dataList,
      total,
    };
  },
  columns: ({ auxiliaryParams, gameInfo }) => {
    const { metrics, hideSentimentRating } = auxiliaryParams;

    let keys = AnalysisMetricList({ hideSentimentRating, gameInfo });
    if (metrics.length > 0) {
      keys = keys.filter(item => {
        return metrics.includes(item.value);
      });
    }
    const list = keys.map(({ value, text, header, ...props }) => {
      return {
        key: value === "tweets_view" ? "view" : value,
        header: header || text,
        ...props,
      };
    });
    return list;
  },
};
